<template>
  <div class="navbar navbar-inverse">
    <div class="navbar-header">
      <!-- <router-link to="/" class="navbar-brand"> -->
        <!-- <img src="../images/header_logo.png" alt=""> -->
      <!-- </router-link> -->
      <ul class="nav navbar-nav visible-xs-block">
        <li>
          <a data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
          </a>
        </li>
        <li>
          <a class="sidebar-mobile-main-toggle">
            <i class="icon-paragraph-justify3"></i>
          </a>
        </li>
      </ul>
    </div>
    <div class="navbar-collapse collapse">
      <div class="user-wrapper">
        <div class="user-text">
          {{headerLan.hello}}&nbsp;!&nbsp;{{user.user_name}}&nbsp;&nbsp;{{headerLan.userName}}
        </div> 
      </div> 
      <ul class="nav navbar-nav navbar-right">
        <dropdown tag="li">
          <a role="button" data-role="trigger" class="dropdown-toggle">
            <img :src="languageImage" class="position-left language">
            <span>{{headerLan.language}}</span>
            <span class="caret"></span>
          </a>
          <template slot="dropdown">
            <li @click="changeLanguage('cn')">
              <a class="china language"><img class="language" src="/static/limitless/assets/images/flags/cn.png">简体中文</a>
            </li>
            <li @click="changeLanguage('hk')">
              <a class="english"><img class="language" src="/static/limitless/assets/images/flags/hk.png">繁體中文</a>
            </li>
            <li @click="changeLanguage('en')">
              <a class="english"><img class="language" src="/static/limitless/assets/images/flags/en.png">English</a>
            </li>
          </template>
        </dropdown>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { Dropdown } from 'uiv'
import { URL_SIGNOUT } from '../api/api.js'

export default {
  mixins: [
    require("common/mixin/base.js").base({headerLan:"header"})
  ],
  data() {
    return {
      user: JSON.parse(sessionStorage.user),
      setLanguageShow: false,
      isLogOut:false,
      menunum: 0,
      language: ''
    }
  },
  mounted() {
  },
  computed: {
    languageImage() {
      return `/static/limitless/assets/images/flags/${this.LANGUAGE}.png`
    }
  },
  methods: {
    sureFn() {
      var that = this;                          //确定退出登录按钮
      this.isLogOut = !this.isLogOut
      that.$http.get(URL_SIGNOUT, {
        headers: { 'Content-Type': 'application/json' }
      }).then(function(res) {
        console.log(res);
        if(res.data.code=='0'){
            that.$router.push({
              path: `login`
            });
        }else{
          alert(res.data.msg)
        }

      }).catch(function(err) {
        console.log(err);
      })
    },
     noFn() {                           ////取消退出登录按钮
      this.isLogOut = !this.isLogOut
    },
    logOutFn() {                      //退出登录
      this.isLogOut=!this.isLogOut;
    },
    changeLanguage(language) {
      this.SAVELANGUAGE(language)
      localStorage.language = language
    }
  },
  components: {
    Dropdown
  }
}
</script>

<style lang="scss" type="text/scss">
.navbar-inverse {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: #3F51B5;
  border-color: #3F51B5;
  z-index:100;
  .user-wrapper{
    float: right;
    height: 46px;
    line-height: 46px;
  }
  .navbar-nav .language-switch a>img {
    top: 0px;
  }
  .dropdown-menu {
    .language {
      margin-top: 5px;
    }
  }
}

</style>




// WEBPACK FOOTER //
// header.vue?c6e50876